export { FriendReferralPageV2 } from "./FriendReferralV2"
